// extracted by mini-css-extract-plugin
export default {"main":"app-bottom_main__wS0uy","part":"app-bottom_part__4wJGy"};